import { render, staticRenderFns } from "./AutomatorDocsCommandList.vue?vue&type=template&id=71d16626&scoped=true"
import script from "./AutomatorDocsCommandList.vue?vue&type=script&lang=js"
export * from "./AutomatorDocsCommandList.vue?vue&type=script&lang=js"
import style0 from "./AutomatorDocsCommandList.vue?vue&type=style&index=0&id=71d16626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d16626",
  null
  
)

export default component.exports